import { useState } from 'react';

/**
 * Gambar sampul dengan cadangan judul.
 *
 * Sebagian platform mengirim URL cover yang MATI (mis. `shorten` — proxy
 * gambar QuickPlay balas 500 dan sumber aslinya balas 400), dan sebagian
 * lain mengirim gambar 0-byte yang "berhasil" dimuat tapi kosong. Tanpa
 * penanganan ini, yang terlihat user cuma kotak gelap tanpa keterangan.
 *
 * Mengisi penuh elemen induknya, jadi induknya yang mengatur ukuran/rounded.
 */
export function Poster({
  src,
  title,
  className = '',
}: {
  src: string | null;
  title: string;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);

  if (src === null || src.length === 0 || failed) {
    return (
      <div
        className={`grid h-full w-full place-items-center bg-gradient-to-br from-ink-800 to-ink-900 p-2 text-center ${className}`}
      >
        <span className="line-clamp-3 text-[10px] font-medium leading-snug text-neutral-400">
          {title}
        </span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt=""
      loading="lazy"
      // Tanpa ini, menyeret dari atas gambar memicu drag-and-drop bawaan
      // peramban di desktop — pointer event kita dibatalkan dan geseran
      // carousel mati di tengah jalan.
      draggable={false}
      className={`h-full w-full object-cover ${className}`}
      onError={() => setFailed(true)}
      // Gambar 0-byte tetap memicu onLoad — deteksi lewat naturalWidth.
      onLoad={(e) => {
        if ((e.currentTarget as HTMLImageElement).naturalWidth === 0) {
          setFailed(true);
        }
      }}
    />
  );
}
